import { type ReactNode } from 'react'

import { LoadingSpinner } from '@/components/ui/LoadingSpinner'

import { Button } from './Button'

interface FormSubmitButtonProps {
  isLoading: boolean
  isValid: boolean
  canWrite: boolean
  writeGateResource: string
  children: ReactNode
}

/**
 * Submit button that gates on form validity, in-flight state, and write access.
 *
 * Encapsulates the `disabled` + tooltip pattern so callers don't repeat the
 * three-way OR and the title ternary (which trips ESLint's complexity rule
 * when inlined in form bodies).
 */
export function FormSubmitButton({
  isLoading,
  isValid,
  canWrite,
  writeGateResource,
  children,
}: FormSubmitButtonProps) {
  const isDisabled = isLoading || !isValid || !canWrite
  const title = canWrite ? undefined : `Requires ${writeGateResource} write access`

  return (
    <Button type="submit" disabled={isDisabled} title={title}>
      {isLoading && <LoadingSpinner size="sm" className="mr-2" />}
      {children}
    </Button>
  )
}
